import React from 'react';
import classNames from 'classnames';

const THEME_WYSIWYG = 'wysiwyg';
const THEME_SINGLE_LINE = 'single-line';

const Textarea = ({
  id,
  name,
  value,
  theme,
  placeholder,
  onChange = () => {},
  ...props
}) => {
  const className = classNames('c-form__textarea', {
    'c-form__textarea--wysiwyg': theme === THEME_WYSIWYG,
    'c-form__textarea--single-line': theme === THEME_SINGLE_LINE,
  });

  return (
    <textarea
      {...props}
      className={className}
      value={value}
      id={id}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default Textarea;
